import { render, staticRenderFns } from "./typeBar.vue?vue&type=template&id=0395b1c7&"
import script from "./typeBar.vue?vue&type=script&lang=js&"
export * from "./typeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports